<!--
	@name app-conference
	@description Conference page
	@date 2020/05/20
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<div class="hero">
			<v-container fill-height>
				<v-row no-gutters>
					<v-col cols="12" sm="12" class="text-center text-md-left">
						<v-row no-gutters class="mb-10 justify-center justify-md-start">
							<v-col class="shrink">
								<div class="text-h5 text-lg-h4 white--text font-weight-light nowrap">
									Air Conference 10<sup>th</sup> June
								</div>
							</v-col>
							<v-col class="shrink d-none d-lg-block">
								<div class="text-h4 text-lg-h4 white--text mx-4">
									|
								</div>
							</v-col>
							<v-col class="shrink d-none d-lg-block">
								<img :src="'manager_documents/4e73e9e6-a484-4bf6-9e23-17fa06e2dc71.png' | urlize" style="height: 30px;" />
							</v-col>
						</v-row>
						<div class="text-h3 text-lg-h2 text-lg-h2--alt white--text font-weight-bold text-uppercase mb-4">
							The Road to Success
						</div>
						<div class="text-h5 text-lg-h4 text-lg-h4--alt white--text font-weight-regular">
							Begins with Comprehensive Conversations
						</div>
						<v-btn target="_blank" :href="bookingUrl" color="white" outlined class="mt-14" large>
							save your seat
						</v-btn>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<v-container class="section0 py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<div class="text-center d-flex align-center flex-column px-md-10">
				<p class="text-h5 text-md-h4 text-lg-h3 font-weight-bold mb-6" :style="{ 'line-height': $vuetify.breakpoint.lgAndUp ? '3.75rem' : 'auto' }">
					Don't miss out, secure your spot and accelerate your business success
				</p>
				<div v-show="displayCountdown" class="mt-3 mb-6">
					<div class="wrap">
						<div class="countdown countdown-static">
							<div class="bloc-time days" :data-init-value="days">
								<span class="count-title">Days</span>

								<div class="figure days days-1">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>

								<div class="figure days days-2">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>
							</div>

							<div class="bloc-time hours" :data-init-value="hours">
								<span class="count-title">Hours</span>

								<div class="figure hours hours-1">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>

								<div class="figure hours hours-2">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>
							</div>

							<div class="bloc-time min" :data-init-value="minutes">
								<span class="count-title">Minutes</span>

								<div class="figure min min-1">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>

								<div class="figure min min-2">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>
							</div>

							<div class="bloc-time sec" :data-init-value="seconds">
								<span class="count-title">Seconds</span>

								<div class="figure sec sec-1">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>

								<div class="figure sec sec-2">
									<span class="top">0</span>
									<span class="top-back">
										<span>0</span>
									</span>
									<span class="bottom">0</span>
									<span class="bottom-back">
										<span>0</span>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-4">
					This year's annual Air Conference places the spotlight firmly on the customer— with main plenaries focusing on who they are, how you can best identify and understand them, and the strategies needed to acquire and nurture lasting relationships.
				</p>
				<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-0">
					If you're looking for support on lead generation, improving advice efficiency with the latest tech and being on the front foot on all of the latest insights in later life lending, then you can't afford to miss this event.
				</p>
				<div class="mt-10 text-xs-center text-md-left mx-n3">
					<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" target="_blank" :href="bookingUrl">
						save your seat
					</v-btn>
				</div>
			</div>
		</v-container>

		<v-divider />

		<v-container class="section0 py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<div class="text-center text-sm-left d-flex align-center flex-column mx-auto mb-10" style="max-width: 900px;">
				<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-0">
					Agenda
				</p>
			</div>
			<v-timeline class="pb-10 mb-10">
				<v-timeline-item v-for="(date, index) in orderedDates" :key="date.id" fill-dot small color="secondary" class="py-3" :class="{'text-right':index%2!==0}">
					<p class="text-body-1 font-weight-regular mb-1 secondary--text">
						{{ date.start | moment('HH:mm') }} - {{ date.end | moment('HH:mm') }}
					</p>
					<p class="text-h5 mb-3">
						{{ date.name }}
					</p>
					<p class="text-body-1 font-weight-regular mb-0">
						{{ date.description }}
					</p>
				</v-timeline-item>
			</v-timeline>
			<div class="text-center pt-6">
				<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-medium mb-0 text-center">
					With top lenders and experts covering every critical area to help you serve your clients and grow your business, you can't afford to sit this one out. <span class="font-weight-bold">Join the best team in the race!</span>
				</p>
				<div class="mt-10 text-center mx-n3">
					<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" target="_blank" :href="bookingUrl">
						save your seat
					</v-btn>
				</div>
			</div>
		</v-container>
	</div>
</template>

<script>
	import { orderBy } from 'lodash';
	import { gsap, Quart, Back } from 'gsap';

	export default {
		name: 'app-conference',

		components: {},

		data() {
			return {
				displayCountdown: false,
				days: null,
				hours: null,
				minutes: null,
				seconds: null,
				total_seconds: null,
				bookingUrl: 'https://www.eventbrite.co.uk/e/national-later-life-lending-adviser-conference-2025-tickets-1300870200789?aff=Marketing&dm_t=0,0,0,0,0&dm_i=6MPX,16LJU,63V91F,5J6F8,1',
                dates: [
                    {
                    "id": "c8ae9d00-30aa-4652-908d-b74adfc3e542",
                    "name": "Accelerate your knowledge (Education Zone)",
                    "description": "Advance your expertise with tailored learning opportunities from Air Academy, the Equity Release Council and Aviva.",
                    "location": "Forum Hall (Lower floor)",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": "98aff8ec-bec2-44ef-bd9c-f1b285931475",
                    "slots": "[{\"end\": \"2025-06-10T10:50:00.000Z\", \"label\": \"11:20 - 11:50\", \"start\": \"2025-06-10T10:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 8}, {\"end\": \"2025-06-10T11:20:00.000Z\", \"label\": \"11:50 - 12:20\", \"start\": \"2025-06-10T10:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 4}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:17:41.801971+00",
                    "deleted": null
                    },
                    {
                    "id": "98aff8ec-bec2-44ef-bd9c-f1b285931475",
                    "name": "Accelerate your knowledge (Education Zone)",
                    "description": "Advance your expertise with tailored learning opportunities from Air Academy, the Equity Release Council and Aviva.",
                    "location": "Forum Hall (Lower floor)",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "linked_session_id": "c8ae9d00-30aa-4652-908d-b74adfc3e542",
                    "slots": "[{\"end\": \"2025-06-10T12:50:00.000Z\", \"label\": \"13:20 - 13:50\", \"start\": \"2025-06-10T12:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 5}, {\"end\": \"2025-06-10T13:20:00.000Z\", \"label\": \"13:50 - 14:20\", \"start\": \"2025-06-10T12:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 2}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 09:44:32.114264+00",
                    "deleted": null
                    },
                    {
                    "id": "567ce7b1-943f-4780-8cb7-66dca0ea64c8",
                    "name": "Air Opener",
                    "description": "Introduction to the day",
                    "location": "Main stage (Lower floor)",
                    "start": "2025-06-10 08:30:00+00",
                    "end": "2025-06-10 08:40:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-07 15:55:17.798+00",
                    "deleted": null
                    },
                    {
                    "id": "4a0921ab-0446-416a-9cf8-161b0c709b9e",
                    "name": "Break",
                    "description": "Refresh with tea and coffee while connecting with peers and explore the exhibitions.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 13:20:00+00",
                    "end": "2025-06-10 13:35:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "8ba12d9f-312d-4dd1-9f11-2a5d50a862fe",
                    "name": "Break & Networking Opportunities",
                    "description": "Refresh with tea and coffee while connecting with peers and explore the exhibitions.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 09:50:00+00",
                    "end": "2025-06-10 10:20:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "b8f6d3f0-14f5-4a50-a7bc-7d41cfeda72b",
                    "name": "Case Study",
                    "description": "Work with like-minded advisers in a live demonstration that showcases the power of effective questioning to uncover what truly matters to your client.",
                    "location": "Main stage (Lower floor)",
                    "start": "2025-06-10 11:30:00+00",
                    "end": "2025-06-10 12:15:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:20:49.204748+00",
                    "deleted": null
                    },
                    {
                    "id": "c14ffa30-51cf-4cfa-a214-0769d86e2a40",
                    "name": "Closer",
                    "description": "Prize Draw / Photo Opportunities",
                    "location": "Main stage (Lower floor)",
                    "start": "2025-06-10 14:00:00+00",
                    "end": "2025-06-10 14:10:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-07 15:55:17.798+00",
                    "deleted": null
                    },
                    {
                    "id": "cfc33059-6e27-44f5-afc0-11273df32ee9",
                    "name": "Compliance Checkpoint (Compliance & Conveyancing Zone)",
                    "description": "Hear from the experts and discover Air Flow - streamlining customer journeys with seamless workflows and instant documentation to support your compliance.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": "143130e0-a4d7-411f-8387-abe61cec42a7",
                    "slots": "[{\"end\": \"2025-06-10T10:50:00.000Z\", \"label\": \"11:20 - 11:50\", \"start\": \"2025-06-10T10:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 2}, {\"end\": \"2025-06-10T11:20:00.000Z\", \"label\": \"11:50 - 12:20\", \"start\": \"2025-06-10T10:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 3}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 09:44:25.374084+00",
                    "deleted": null
                    },
                    {
                    "id": "143130e0-a4d7-411f-8387-abe61cec42a7",
                    "name": "Compliance Checkpoint (Compliance & Conveyancing Zone)",
                    "description": "Hear from the experts and discover Air Flow - streamlining customer journeys with seamless workflows and instant documentation to support your compliance.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "linked_session_id": "cfc33059-6e27-44f5-afc0-11273df32ee9",
                    "slots": "[{\"end\": \"2025-06-10T12:50:00.000Z\", \"label\": \"13:20 - 13:50\", \"start\": \"2025-06-10T12:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 7}, {\"end\": \"2025-06-10T13:20:00.000Z\", \"label\": \"13:50 - 14:20\", \"start\": \"2025-06-10T12:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 5}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:18:45.528142+00",
                    "deleted": null
                    },
                    {
                    "id": "b730a6f7-f713-4f83-b81a-c06f0ee25413",
                    "name": "Compliance Collaboration Corner",
                    "description": "Exclusive session with Charlotte Allen (Chief Compliance and Risk Officer ) — collaborate with peers to shape the future of compliance and risk.",
                    "location": "Mezzanine",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": true,
                    "bookable": true,
                    "parallel": false,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 13:38:07.607212+00",
                    "deleted": null
                    },
                    {
                    "id": "92850e22-b2b0-4dd9-82f2-2e59faab9345",
                    "name": "Final Break & Networking",
                    "description": "Make the most of this final chance to network with peers and explore the exhibitions before the Conference closes.",
                    "location": null,
                    "start": "2025-06-10 14:10:00+00",
                    "end": "2025-06-10 14:40:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "fa60a565-718f-4d05-a049-9c1fe45cba1a",
                    "name": "Get Fit for the Future with Air & Ambassadors",
                    "description": "Join Air and our Ambassadors for 'Get Fit for the Future': this is a relaxed networking opportunity to share ideas, network and collaborate.",
                    "location": "Main Stage (Lower floor)",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": false,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": "92316f2b-f804-4f34-97e3-e99f33d727de",
                    "slots": null,
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 13:38:07.607212+00",
                    "deleted": null
                    },
                    {
                    "id": "92316f2b-f804-4f34-97e3-e99f33d727de",
                    "name": "Get Fit for the Future with Air & Ambassadors",
                    "description": "Join Air and our Ambassadors for 'Get Fit for the Future': this is a relaxed networking opportunity to share ideas, network and collaborate.",
                    "location": "Main Stage (Lower floor)",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": false,
                    "parent_id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "linked_session_id": "fa60a565-718f-4d05-a049-9c1fe45cba1a",
                    "slots": null,
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 13:38:07.607212+00",
                    "deleted": null
                    },
                    {
                    "id": "9b71a57a-2d01-47cc-be02-e146e9f89df1",
                    "name": "Lead Generation Tune-Up (Lead Generation Zone)",
                    "description": "Collaborate with marketing specialists to uncover strategies resources and tools that drive sustainable growth.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": "16117bbc-26c9-43ec-ba2d-a5c3e46547af",
                    "slots": "[{\"end\": \"2025-06-10T10:50:00.000Z\", \"label\": \"11:20 - 11:50\", \"start\": \"2025-06-10T10:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 6}, {\"end\": \"2025-06-10T11:20:00.000Z\", \"label\": \"11:50 - 12:20\", \"start\": \"2025-06-10T10:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 5}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 09:46:05.303015+00",
                    "deleted": null
                    },
                    {
                    "id": "16117bbc-26c9-43ec-ba2d-a5c3e46547af",
                    "name": "Lead Generation Tune-Up (Lead Generation Zone)",
                    "description": "Collaborate with marketing specialists to uncover strategies resources and tools that drive sustainable growth.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "linked_session_id": "9b71a57a-2d01-47cc-be02-e146e9f89df1",
                    "slots": "[{\"end\": \"2025-06-10T12:50:00.000Z\", \"label\": \"13:20 - 13:50\", \"start\": \"2025-06-10T12:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 7}, {\"end\": \"2025-06-10T13:20:00.000Z\", \"label\": \"13:50 - 14:20\", \"start\": \"2025-06-10T12:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 5}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:18:45.528142+00",
                    "deleted": null
                    },
                    {
                    "id": "9341a603-fb20-426e-bf84-727a6a654fb9",
                    "name": "Lunch Break",
                    "description": "Networking– Exhibitions– Speak to the Air Team​",
                    "location": "Forum Hall (Lower floor)",
                    "start": "2025-06-10 11:20:00+00",
                    "end": "2025-06-10 12:20:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:20:18.694812+00",
                    "deleted": null
                    },
                    {
                    "id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "name": "Pit Stop 1: Interactive Clinics",
                    "description": "Choose two of four clinics across key zones. Limited spaces—join practical discussions to support your business.",
                    "location": "Various locations",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 15:09:15.134584+00",
                    "deleted": null
                    },
                    {
                    "id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "name": "Pit Stop 2: Interactive Clinics",
                    "description": "Choose two of four clinics across key zones. Limited spaces—join practical discussions to support your business.",
                    "location": "Various locations",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 15:09:15.134584+00",
                    "deleted": null
                    },
                    {
                    "id": "744bf979-fbae-4657-8859-63a15a588920",
                    "name": "Plenary 1: In the Driver's Seat",
                    "description": "Are you ready for the new over-50s? Diverse, digital, and demanding more—this session shows you how to keep up and stay ahead.",
                    "location": "Main stage (Lower floor)",
                    "start": "2025-06-10 08:40:00+00",
                    "end": "2025-06-10 09:00:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "45511b1e-2b7c-4d83-878c-4c2c1068d74b",
                    "name": "Plenary 2: From Pit Lane to Pole Position",
                    "description": "The race for the over-50s is on. Advisers need bold, insight-led strategies to engage this complex, high-value audience.",
                    "location": "Main stage (Lower floor)",
                    "start": "2025-06-10 09:00:00+00",
                    "end": "2025-06-10 09:50:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "945a4525-a365-4d3c-abe0-23fb7eb113cc",
                    "name": "Plenary 3: Motivational Speaker",
                    "description": "Get inspired by F1 strategist and engineer, Ruth Buscombe, as she shares high-performance insights on strategy, resilience, and succeeding under pressure.",
                    "location": "Main stage (lower floor)",
                    "start": "2025-06-10 13:35:00+00",
                    "end": "2025-06-10 14:00:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-13 08:27:34.703662+00",
                    "deleted": null
                    },
                    {
                    "id": "d389eeda-ca68-45ec-a643-8f7d234af0bb",
                    "name": "Registration",
                    "description": "Coffee/tea, early networking opportunity - Exhibitions - Speak to the Air team",
                    "location": "Welcome Desk (Upper floor)",
                    "start": "2025-06-10 07:30:00+00",
                    "end": "2025-06-10 08:30:00+00",
                    "exclusive": false,
                    "bookable": false,
                    "parallel": false,
                    "parent_id": null,
                    "linked_session_id": null,
                    "slots": null,
                    "qr_code": null,
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-07 15:55:17.798+00",
                    "deleted": null
                    },
                    {
                    "id": "7b7ecce2-47c3-41a2-9b2d-933056f16eb7",
                    "name": "Take a Tech Lap (Fact-Find & Sourcing Zone)",
                    "description": "Explore Air's WriteRoute, Sourcing tools and new lender technology, with expert guidance to confidently match products to your clients' needs.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 10:20:00+00",
                    "end": "2025-06-10 11:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "51b5fa6c-1e7e-429e-878d-d82972aeac29",
                    "linked_session_id": "a83f8d16-5a37-4f7e-bd3e-41ab8322f141",
                    "slots": "[{\"end\": \"2025-06-10T10:50:00.000Z\", \"label\": \"11:20 - 11:50\", \"start\": \"2025-06-10T10:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 3}, {\"end\": \"2025-06-10T11:20:00.000Z\", \"label\": \"11:50 - 12:20\", \"start\": \"2025-06-10T10:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 8}]",
                    "qr_code": "data:image/png;base64,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",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 14:17:41.801971+00",
                    "deleted": null
                    },
                    {
                    "id": "a83f8d16-5a37-4f7e-bd3e-41ab8322f141",
                    "name": "Take a Tech Lap (Fact-Find & Sourcing Zone)",
                    "description": "Explore Air's WriteRoute, Sourcing tools and new lender technology, with expert guidance to confidently match products to your clients' needs.",
                    "location": "Exhibition Hall (Upper floor)",
                    "start": "2025-06-10 12:20:00+00",
                    "end": "2025-06-10 13:20:00+00",
                    "exclusive": false,
                    "bookable": true,
                    "parallel": true,
                    "parent_id": "e76e2487-05c5-4d47-82f1-fb8381fa1b1d",
                    "linked_session_id": "7b7ecce2-47c3-41a2-9b2d-933056f16eb7",
                    "slots": "[{\"end\": \"2025-06-10T12:50:00.000Z\", \"label\": \"13:20 - 13:50\", \"start\": \"2025-06-10T12:20:00.000Z\", \"value\": \"first\", \"capacity\": 30, \"usedCapacity\": 2}, {\"end\": \"2025-06-10T13:20:00.000Z\", \"label\": \"13:50 - 14:20\", \"start\": \"2025-06-10T12:50:00.000Z\", \"value\": \"second\", \"capacity\": 30, \"usedCapacity\": 7}]",
                    "qr_code": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAACkCAYAAAAZtYVBAAAAAklEQVR4AewaftIAAAYqSURBVO3BQY4kyRHAQDLQ//8yNUfXJYFEVc+GVm5mf7DWJQ5rXeSw1kUOa13ksNZFDmtd5LDWRQ5rXeSw1kUOa13ksNZFDmtd5LDWRQ5rXeSw1kUOa13khw+p/E0VT1SeVDxRmSqeqEwVk8obFU9UnlRMKn9TxScOa13ksNZFDmtd5Icvq/gmlU9UTCpPKiaVb6qYVCaVJxWfqPgmlW86rHWRw1oXOax1kR9+mcobFW+oTBWTyhsqU8UnKr5JZar4hMobFb/psNZFDmtd5LDWRX5Y/6XiicpUMalMFZPKVPFE5YnKVPG/7LDWRQ5rXeSw1kV++Jer+JsqJpUnKlPFVDGp/Jsd1rrIYa2LHNa6yA+/rOJvUnlSMal8k8qTiknlicpU8U0VNzmsdZHDWhc5rHWRH75M5Z9UMam8UTGpTBWTylQxqfwmlaniicrNDmtd5LDWRQ5rXcT+4H+YyhsVk8pU8URlqvgmlScV/2aHtS5yWOsih7Uu8sOHVKaKSeWbKqaKSeWNikllqnii8qTijYpJ5YnKVDGpfFPFbzqsdZHDWhc5rHWRH35ZxROVqeKJyidU3lCZKt5QeVIxqUwVk8onKj6h8qTiE4e1LnJY6yKHtS5if/ABlaliUpkqnqg8qXiiMlV8QuVJxaTypOKbVJ5UTCqfqPhNh7UucljrIoe1LmJ/8AGVb6p4Q+VJxaQyVTxReVLxROVJxaQyVUwq31QxqbxR8U2HtS5yWOsih7Uu8sOXVUwqU8UTlTcqnqhMFW9UPFF5o2JSmSomlTcq3lB5UvE3Hda6yGGtixzWusgPX6YyVUwqb1RMKm9UTCpPKp6oTBWTylQxqUwVk8pUMalMFU9UnlRMKpPKVDGpTBWfOKx1kcNaFzmsdZEffpnKVPFEZVKZKp6oPKn4J1V8ouKNiicqU8UTlanimw5rXeSw1kUOa13kh19WMalMFVPFE5Wp4jepTBWTylTxhsoTlScVk8obFU9U/qbDWhc5rHWRw1oXsT/4IpWp4onKGxWTypOKJyq/qeKJylQxqUwVT1SmiicqU8U/6bDWRQ5rXeSw1kXsD/4ilTcqJpWpYlJ5o2JSmSreUPknVUwqU8UbKm9UfOKw1kUOa13ksNZFfvgylaniScUTlScqU8UTlUllqnii8qRiUpkqJpU3Kp6ofFPF33RY6yKHtS5yWOsiP3xZxaQyVUwqTyomlZtUfKJiUpkqJpWp4knFGypPKn7TYa2LHNa6yGGti/zwZSpTxaTypGJSeVIxqUwVU8UTlU+ovKEyVTypeFLxhsqTikllqvimw1oXOax1kcNaF7E/+IDKVDGpPKn4hMo3VUwqU8WkMlU8UZkqJpW/qWJSmSqeqEwVnzisdZHDWhc5rHWRH35ZxaTyhspU8UbFpPIJlanijYpJ5UnFE5WpYlKZKt5QeVLxTYe1LnJY6yKHtS7ywy9TeaLypOKbKiaVNyreUJkqPqEyVUwqU8WkMlVMFZPKE5Wp4hOHtS5yWOsih7Uu8sNfVjGpTBWTypOKT1S8oTJVTCpTxaTypGJSmSomlScqT1SeVDxR+abDWhc5rHWRw1oX+eFDFU8qnlQ8qXii8qTimyomlaliUnlD5RMVb6hMFZPKVPGbDmtd5LDWRQ5rXeSHD6n8TRVTxROVJxVvqDxReVIxqUwVT1TeUJkqnqhMFZPKVPFNh7UucljrIoe1LvLDl1V8k8oTlaliqnhD5UnFpDJVPFF5ovJNFZ9QmSp+02GtixzWushhrYv88MtU3qj4hMonKiaVN1TeqHiiMlVMKpPKJyreUJkqPnFY6yKHtS5yWOsiP/zLVEwqTyo+UfGGyhOVqeJJxaQyVTxRmVT+SYe1LnJY6yKHtS7yw/+ZiknlDZWp4o2KSeUNlaliqphUpoqpYlJ5UvGbDmtd5LDWRQ5rXeSHX1bxmyreUHmj4iYVT1SmiicqNzmsdZHDWhc5rHWRH75M5W9SeaPiicqk8qRiUnlSMVW8ofKk4hMVT1Smim86rHWRw1oXOax1EfuDtS5xWOsih7UucljrIoe1LnJY6yKHtS5yWOsih7UucljrIoe1LnJY6yKHtS5yWOsih7UucljrIv8B80cDZt0PuTkAAAAASUVORK5CYII=",
                    "created": "2025-05-07 15:55:17.798+00",
                    "updated": "2025-05-28 09:46:20.719213+00",
                    "deleted": null
                    }
                ]
			};
		},

		computed: {
			nextEvent() {
                return {
                    "start": "2025-06-10T08:30:00.000Z"
                };
			},

            orderedDates() {
                return orderBy(this.dates.filter((x) => !x.parent_id && !x.deleted), 'start', 'asc');
            }
		},

		mounted() {
			this.init();
		},

		methods: {
			init() {
				var t1 = new Date(this.nextEvent.start);
				var t2 = new Date();
				var dif = t1.getTime() - t2.getTime();
				if (dif < 0) return;

				this.total_seconds = Math.ceil(Math.abs(dif / 1000));
				var delta = this.total_seconds;

				this.days = Math.floor(delta / 86400);
				delta -= this.days * 86400;
				// calculate (and subtract) whole hours
				this.hours = Math.floor(delta / 3600);
				delta -= this.hours * 3600;

				// calculate (and subtract) whole minutes
				this.minutes = Math.floor(delta / 60);
				delta -= this.minutes * 60;

				// what's left is seconds
				this.seconds = Math.floor(delta % 60); // in theory the modulus is not required

				// Init countdown values
				this.values = {
					days: this.days,
					hours: this.hours,
					minutes: this.minutes,
					seconds: this.seconds
				};

				let selector = '.countdown-static';
				this.objel = document.querySelector(selector);

				// DOM
				this.obj = {
					days: this.objel.querySelectorAll('.bloc-time.days .figure'),
					hours: this.objel.querySelectorAll('.bloc-time.hours .figure'),
					minutes: this.objel.querySelectorAll('.bloc-time.min .figure'),
					seconds: this.objel.querySelectorAll('.bloc-time.sec .figure')
				};

				// Animate countdown to the end
				if (this.days < 100) {
					this.displayCountdown = true;
					this.count(this.obj);
				}
			},

			count(obj) {
				var that = this,
					$day_1 = obj.days[0],
					$day_2 = obj.days[1],
					$hour_1 = obj.hours[0],
					$hour_2 = obj.hours[1],
					$min_1 = obj.minutes[0],
					$min_2 = obj.minutes[1],
					$sec_1 = obj.seconds[0],
					$sec_2 = obj.seconds[1];

				if (this.countdown_interval) clearInterval(this.countdown_interval);

				this.countdown_interval = setInterval(() => {
					if (that.total_seconds > 0) {
						--that.values.seconds;

						if (that.values.minutes >= 0 && that.values.seconds < 0) {
							that.values.seconds = 59;
							--that.values.minutes;
						}

						if (that.values.hours >= 0 && that.values.minutes < 0) {
							that.values.minutes = 59;
							--that.values.hours;
						}

						if (that.values.days >= 0 && that.values.hours < 0) {
							that.values.hours = 23;
							--that.values.days;
						}

						// Days
						that.checkHour(that.values.days, $day_1, $day_2);
						// Hours
						that.checkHour(that.values.hours, $hour_1, $hour_2);
						// Minutes
						that.checkHour(that.values.minutes, $min_1, $min_2);
						// Seconds
						that.checkHour(that.values.seconds, $sec_1, $sec_2);

						--that.total_seconds;
					} else {
						this.displayCountdown = false;
						clearInterval(that.countdown_interval);
					}
				}, 1000);
			},

			animateFigure($el, value) {
				var $top = $el.querySelectorAll('.top'),
					$bottom = $el.querySelectorAll('.bottom'),
					$back_top = $el.querySelectorAll('.top-back'),
					$back_bottom = $el.querySelectorAll('.bottom-back');

				// Before we begin, change the back value
				$back_top[0].querySelectorAll('span')[0].innerHTML = value;

				// Also change the back bottom value
				$back_bottom[0].querySelectorAll('span')[0].innerHTML = value;

				// Then animate
				gsap.to($top[0], {
					rotationX: '-180deg',
					transformPerspective: 300,
					ease: Quart.easeOut,
					duration: 0.8,
					onComplete() {
						$top[0].innerHTML = value;
						$bottom[0].innerHTML = value;
						gsap.set($top[0], { rotationX: 0 });
					}
				});

				gsap.to($back_top[0], {
					rotationX: 0,
					transformPerspective: 300,
					ease: Back.easeOut,
					scaleX: 0.98,
					duration: 0.8,
					clearProps: 'all'
				});
			},

			checkHour(value, $el_1, $el_2) {
				var val_1 = value.toString().charAt(0),
					val_2 = value.toString().charAt(1),
					fig_1_value = $el_1.querySelectorAll('.top'),
					fig_2_value = $el_2.querySelectorAll('.top');

				if (value >= 10) {
					// Animate only if the figure has changed
					if (fig_1_value[0].innerHTML !== val_1) this.animateFigure($el_1, val_1);
					if (fig_2_value[0].innerHTML !== val_2) this.animateFigure($el_2, val_2);
				} else {
					// If we are under 10, replace first figure with 0
					if (fig_1_value[0].innerHTML !== '0') this.animateFigure($el_1, 0);
					if (fig_2_value[0].innerHTML !== val_1) this.animateFigure($el_2, val_1);
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
    .hero {
        height: 500px;
		background-position: 950px 50%, 0%;
		background-size: contain;
		background-repeat: no-repeat;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/f776a6a1-a9a5-4760-a593-4fece1eee6e1.png'), linear-gradient(0, #302875 0%, #5354c0 100%);

		@media #{map-get($display-breakpoints, 'lg-and-up')} {
			.text-lg-h2--alt {
				font-size: 4.5rem !important;
				line-height: 4.5rem !important;
			}
			.text-lg-h4--alt {
				font-size: 2.5rem !important;
				line-height: 3rem !important;
			}
		}
	}

	@function tint($color, $percentage) {
		@return mix(white, $color, $percentage);
	}

	// Variables
	$lato: 'Roboto';
	$cardCol1: tint(rgb(27, 110, 216), 0%);
	$cardCol2: tint(rgb(27, 110, 216), 10%);

	// Countdown
	.countdown {
		width: 540px;
		margin: 0 auto 20px;
		display: flex;

		.bloc-time {
			text-align: center;
			flex-grow: 1;
			flex-shrink: 1;
			padding: 4px;
			flex-basis: 20%;

			&:last-child {
				margin-right: 0;
			}
		}

		.count-title {
			display: block;
			margin-bottom: 8px;
			font: normal 0.94em $lato;
			//color: #55acb8;
			//color: #f0acb8;
			text-transform: uppercase;
			font-weight: 500;
		}

		.figure {
			position: relative;
			float: left;
			height: 3.6rem;
			width: 46%;
			margin: 0 2%;
			background-color: $cardCol1;
			border-radius: 8px;
			box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25), inset 2px 4px 0 0 rgba(255, 255, 255, 0.08);

			&:last-child {
				margin-right: 0;
			}

			> span {
				position: absolute;
				left: 0;
				right: 0;
				margin: auto;
				font: normal 2.5rem $lato;
				line-height: 3.6rem;
				font-weight: 400;
				color: rgba(255, 255, 255, 0.6);
			}

			&.days {
				> span {
					color: rgba(255, 255, 255, 0.8);
				}
			}

			.top,
			.bottom-back {
				&:after {
					content: '';
					position: absolute;
					z-index: -1;
					left: 0;
					bottom: 0;
					width: 100%;
					height: 100%;
					border-bottom: 1px solid rgba(0, 0, 0, 0.1);
				}
			}

			.top {
				z-index: 3;
				background-color: $cardCol2;
				transform-origin: 50% 100%;
				-webkit-transform-origin: 50% 100%;
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;
				transform: perspective(200px);
			}

			.bottom {
				z-index: 1;

				&:before {
					content: '';
					position: absolute;
					display: block;
					top: 0;
					left: 0;
					width: 100%;
					height: 50%;
					background-color: rgba(0, 0, 0, 0.02);
				}
			}

			.bottom-back {
				z-index: 2;
				top: 0;
				height: 50%;
				overflow: hidden;
				background-color: $cardCol2;
				border-top-left-radius: 10px;
				border-top-right-radius: 10px;

				span {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					margin: auto;
				}
			}

			.top,
			.top-back {
				height: 50%;
				overflow: hidden;
				backface-visibility: hidden;
			}

			.top-back {
				z-index: 4;
				bottom: 0;
				background-color: #fff;
				background-color: $cardCol1;
				-webkit-transform-origin: 50% 0;
				transform-origin: 50% 0;
				transform: perspective(200px) rotateX(180deg);
				border-bottom-left-radius: 10px;
				border-bottom-right-radius: 10px;

				span {
					position: absolute;
					top: -100%;
					left: 0;
					right: 0;
					margin: auto;
				}
			}
		}
	}

	.wrap {
		background-position: 50% 50%;
		background-size: cover;
	}
</style>
